import React, { useRef } from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import InterestedInUsedGMC from './InterestedInUsedGMC';

const ClpExoticVehicleInspectionInBoerneTx = () => {
    
        const sliderRef = useRef(null);
        const settings = {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        };
    return (
        <>
            <SeoMeta
                title="Exotic Vehicle Inspection - Mark Motors In Boerne & Austin TX"
                description="If you’re a luxury car owner and looking for an exotic vehicle inspection in Boerne & Austin TX, you can come to us at our dealership, Mark Motors."
                keywords=""
                ogTitle="Exotic Vehicle Inspection - Mark Motors In Boerne & Austin TX"
                ogDescription="If you’re a luxury car owner and looking for an exotic vehicle inspection in Boerne & Austin TX, you can come to us at our dealership, Mark Motors."
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">
                        <h1>Exotic Vehicle Inspection in Boerne, TX</h1>
                        <div className="row gx-5 mt-5">
                            <div className="col-md-6">
                                <Link to="/schedule-car-maintenance-or-auto-repair-boerne-tx">
                                    <img src={getImages('new/vehicle_inspection_featured_b.jpg')} alt='a technician holding tools while standing in front of a cars hood' />
                                </Link>
                            </div>
                            <div className="col-md-6">
                                <p>If you’re a luxury car owner, you know that these vehicles require extra care than other automobiles. Even if it's something as simple as an oil change, you must get it regularly to keep your vehicle running efficiently. And
                                    the best place for you to service your exotic model in Boerne, TX, is Mark Motors. At our dealership, we’re committed to providing you with the highest level of service every time you visit us. </p>
                                <p>We've a team of skilled and trained professionals who know how to take the best possible care of your luxury car. If you’re not sure whether your vehicle needs a service or repair, bring it to us, and we’ll do a vehicle inspection.
                                    You can contact us by dialing 830-981-5050 if you’ve any repair or maintenance needs. Alternatively, you can click on the link below to schedule an appointment.</p>
                                <div className="mt-3">
                                    <Link className="btn-theme md-btn me-4 d-inline-block" to="/schedule-car-maintenance-or-auto-repair-boerne-tx">Schedule a Service Appointment</Link>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-5 mt-5">
                            <div className="col-md-6">
                                <h2 className='mt-0'>What are the Advantages of a Vehicle Inspection?</h2>
                                <p>First and foremost, a vehicle inspection ensures that your car stays in top-notch condition and is safe to drive on the road. To prevent the need for costly repairs and ensure that you stay safe, you must get a vehicle inspection.
                                    Here are some of the benefits of a vehicle inspection.</p>
                                <ul>
                                    <li>One of the top advantages of a vehicle inspection is that it boosts the lifespan of your vehicle by identifying minor issues and fixing them before they become much bigger issues.</li>
                                    <li>If you’re driving a faulty vehicle, it increases the risk of a collision. Getting a timely vehicle inspection reduces the risk of a collision as your vehicle stays in good shape.</li>
                                    <li>When you get a vehicle inspection, you also get emission testing, ensuring higher air quality and improving your vehicle’s fuel efficiency.</li>
                                </ul>
                                <h2>Why Choose Mark Motors for Your Next Service?</h2>
                                <p>At Mark Motors, we strive to keep exotic vehicles in top-notch condition. Our team of experts is here to take care of your and your vehicle’s needs. At our dealership in Boerne, TX, we also have a wide range of luxury models,
                                    which you can finance at the best rates. Moreover, if you want to sell your old exotic model, you can do so at our dealership without any hassle.</p>
                            </div>
                            <div className="col-md-6">
                                <Slider ref={sliderRef} {...settings} className='common-slider common-dots'>
                                        <img src={getImages('new/vehicle_inspection_sec1_b.jpg')} alt='a technician inspecting a vehicle with a tablet in his hand' />
                                        <img src={getImages('new/vehicle_inspection_sec_b.jpg')} alt='a checklist for vehicle inspection' />
                                </Slider>
                            </div>
                        </div>
                        <div className="mt-5 text-center">
                            <h2 className="mt-0 text-center text-uppercase mb-4">Contact Us to schedule a vehicle inspection</h2>
                            <InterestedInUsedGMC/>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ClpExoticVehicleInspectionInBoerneTx